import { ISelectComPesquisaProps, SelectComPesquisa } from "@/Components/SelectComPesquisa";
import { useDadosBancarioTipoListar } from "@/Services/Pessoa/DadosBancario/DadosBancarioTipoServices";

interface IDadosBancarioTipoSelect extends ISelectComPesquisaProps {
    filtros?:Parameters<typeof useDadosBancarioTipoListar>[0]
}
export default function DadosBancarioTipoSelect({
    loading,
    placeholder,
    allowClear,
    filtros,
    ...rest
}:IDadosBancarioTipoSelect) {
    placeholder = placeholder ?? "Selecione";
    allowClear = allowClear ?? true;
    loading = loading ?? undefined;
    filtros = filtros ?? {
        dadosBancarioTipo : undefined,
        ativo : true
    }

    const {
        data,
        isLoading
    } = useDadosBancarioTipoListar({
        ...filtros
    });

    return <SelectComPesquisa
        {...rest}
        placeholder={placeholder}
        allowClear={allowClear}
        loading={isLoading || loading}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    />
}